export default {
  /**
   * Base URL
   * @param state
   * @returns {default.baseUrl|(function(*))|string|*|string|null}
   */
  baseUrl(state) {
    return state.baseUrl;
  }
};
